<script setup>

import UmisisDeleteItemButton from '@/components/umisis/generic/UmisisDeleteItemButton.vue'
import { Button } from '@/components/ui/button/index.js'
import { useUserManagerStore } from '../../stores/userManagerStore.js'
import UserEditModal from '../users/UserEditModal.vue'
import { Badge } from '../../../../../../../resources/js/components/ui/badge/index.js'
import UserEditRolesModal from './UserEditRolesModal.vue'
const userStore = useUserManagerStore()
const props = defineProps({
  user: {
    type: Object,
    required: true
  }
})

defineEmits('editUser', 'resetPassword', 'deletedUser')

</script>

<template>
  <div class="w-full">
    <div>
      <Badge v-if="props.user.admin"> ADMIN </Badge>
      <h1 class="text-xl">
        {{ props.user.name }}
      </h1>
      <div v-if="props.user.roles?.length > 0" class="flex flex-wrap gap-2 mt-2">
        <span> Roles: </span><Badge v-for="role in props.user.roles" :key="role.id">
          {{ role.name }}
        </badge>
      </div>
    </div>
    <div class="flex flex-col gap-2 sm:flex-row sm:mt-2 sm:items-center sm:justify-start mt-10">
      <Button size="sm" @click="$refs.userEditModal.openModal()">
        {{ $t('userManager.actions.editUser') }}
      </Button>
      <Button size="sm" @click="$emit('resetPassword',props.user)">
        {{ $t('userManager.actions.resetUserPassword') }}
      </Button>
      <Button v-if="!props.user.admin" size="sm" @click="$refs.userEditRolesModal.openModal()">
        {{ $t('userManager.actions.manageRoles') }}
      </Button>
      <UmisisDeleteItemButton v-if="props.user.id > 1" size="sm" :delete-by-value="props.user.id" :use-store="userStore" @deleted="$emit('deletedUser', props.user)" />
      <UserEditModal ref="userEditModal" :user="props.user" />
      <UserEditRolesModal ref="userEditRolesModal" :user="props.user" />
    </div>
  </div>
</template>

<style scoped>

</style>
